import { useEffect, useState } from 'react'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { useSearchUsers } from '@/hooks/useFriends'
import { useAuth } from '@/context/AuthContext'
import FriendRow from '@/components/feature/friends/FriendRow'
import HandleCopy from '@/components/feature/friends/HandleCopy'
import RequestButton from '@/components/feature/friends/RequestButton'

const PAGE_SIZE = 10

export default function FriendSearchPage() {
  const [input, setInput] = useState('')
  const [query, setQuery] = useState('')
  const [offset, setOffset] = useState(0)

  // 入力をデバウンスして検索クエリに反映
  useEffect(() => {
    const t = setTimeout(() => {
      setQuery(input.trim())
      setOffset(0)
    }, 300)
    return () => clearTimeout(t)
  }, [input])

  const { user } = useAuth()
  const { data, isLoading } = useSearchUsers(query, offset, PAGE_SIZE)
  const results = data?.results ?? []
  const total = data?.count ?? 0
  const hasMore = offset + PAGE_SIZE < total

  return (
    <div className="flex flex-col">
      {user && (
        <HandleCopy label="あなたのユーザーID" handle={user.handle} className="pt-3" />
      )}

      <div className="py-3">
        <Input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="ユーザーID（6文字）で検索"
        />
      </div>

      {query.length === 0 ? (
        <p className="py-10 text-center text-sm text-muted-foreground">
          ユーザーID（6文字）の完全一致で検索できます。
        </p>
      ) : isLoading ? (
        <p className="py-10 text-center text-sm text-muted-foreground">検索中…</p>
      ) : results.length === 0 ? (
        <p className="py-10 text-center text-sm text-muted-foreground">
          見つかりませんでした。
        </p>
      ) : (
        <div className="divide-y">
          {results.map((u) => (
            <FriendRow
              key={u.id}
              nickname={u.nickname}
              handle={u.handle}
              avatarUrl={u.avatar_url}
              power={u.power}
              actions={<RequestButton userId={u.id} relation={u.relation} />}
            />
          ))}
        </div>
      )}

      {hasMore && (
        <Button variant="ghost" className="mt-2" onClick={() => setOffset(offset + PAGE_SIZE)}>
          もっと見る
        </Button>
      )}
    </div>
  )
}
